import { useSelector } from 'react-redux'
import {
  builderTypeSelector,
  projectSupportSelector,
} from 'apps/formsCreationKit/store/selectors/workspaceConfig'
import {
  LabelInput,
  EntryTypeSelect,
  DefaultValueInput,
  DefaultMultiLineValueInput,
  RequiredToggle,
  ReadOnlyToggle,
  StandardDesignConfig,
  HideOnPdfToggle,
} from 'apps/studio/components/settings/fields/Base/standard'
import { buildTextSystemDefaultOptions } from 'lib/buildTextSystemDefaultOptions'
import { lib } from '@gocanvas/client'
const {
  TEXT_STYLE,
  TEXT_EMAIL_FORMAT_STYLE,
  TEXT_EMAIL_FORMAT_ALWAYS_STYLE,
  TEXT_NUMBER_FORMAT_STYLE,
  TEXT_USER_NAME_STYLE,
  TEXT_COMPANY_NAME_STYLE,
  TEXT_FIRST_NAME_STYLE,
  TEXT_LAST_NAME_STYLE,
  TEXT_FULL_NAME_STYLE,
  TEXT_CUSTOMER_CODE_STYLE,
  TEXT_SITE_CODE_STYLE,
  TEXT_PROJECT_CODE_STYLE,
  TEXT_GOCANVAS_USER_ID_STYLE,
} = lib

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

const TextFormatSelect = {
  label: 'Format',
  settingType: 'selectInput',
  property: 'style',
  additionalValueMatches: {
    [TEXT_EMAIL_FORMAT_ALWAYS_STYLE]: TEXT_EMAIL_FORMAT_STYLE,
    [TEXT_USER_NAME_STYLE]: TEXT_STYLE,
    [TEXT_COMPANY_NAME_STYLE]: TEXT_STYLE,
    [TEXT_FIRST_NAME_STYLE]: TEXT_STYLE,
    [TEXT_LAST_NAME_STYLE]: TEXT_STYLE,
    [TEXT_FULL_NAME_STYLE]: TEXT_STYLE,
    [TEXT_CUSTOMER_CODE_STYLE]: TEXT_STYLE,
    [TEXT_SITE_CODE_STYLE]: TEXT_STYLE,
    [TEXT_PROJECT_CODE_STYLE]: TEXT_STYLE,
    [TEXT_GOCANVAS_USER_ID_STYLE]: TEXT_STYLE,
  },
  choices: [
    { value: TEXT_STYLE, label: 'None' },
    { value: TEXT_EMAIL_FORMAT_STYLE, label: 'Email' },
    { value: TEXT_NUMBER_FORMAT_STYLE, label: 'Number' },
  ],
  isDisabled: ({ style }) =>
    ![
      TEXT_STYLE,
      TEXT_EMAIL_FORMAT_ALWAYS_STYLE,
      TEXT_NUMBER_FORMAT_STYLE,
      TEXT_EMAIL_FORMAT_STYLE,
    ].includes(Number(style)),
}

const SendSubmissionToEmail = {
  label: 'Always email submissions to this address?',
  settingType: 'toggleInput',
  tooltip:
    'If checked, the email address entered into this field will receive the submission email. Mobile users will not be able to see or delete this email address when completing the submission.',
  property: 'style',
  choices: [
    {
      value: TEXT_EMAIL_FORMAT_ALWAYS_STYLE,
      previousValue: TEXT_EMAIL_FORMAT_STYLE,
    },
    {
      value: TEXT_EMAIL_FORMAT_STYLE,
      previousValue: TEXT_EMAIL_FORMAT_ALWAYS_STYLE,
    },
  ],
  showInput: ({ style }) => {
    const builderType = useSelector(builderTypeSelector)
    return (
      builderType !== 'web-form' &&
      [TEXT_EMAIL_FORMAT_ALWAYS_STYLE, TEXT_EMAIL_FORMAT_STYLE].includes(style)
    )
  },
}

const TextSystemDefaultSelect = {
  label: 'System Default',
  settingType: 'selectInput',
  updateType: 'entry',
  property: 'style',
  additionalValueMatches: {
    [TEXT_STYLE]: TEXT_STYLE,
    [TEXT_EMAIL_FORMAT_ALWAYS_STYLE]: TEXT_STYLE,
    [TEXT_EMAIL_FORMAT_STYLE]: TEXT_STYLE,
    [TEXT_NUMBER_FORMAT_STYLE]: TEXT_STYLE,
  },
  dynamicChoices: () => {
    const projectSupport = useSelector(projectSupportSelector)
    return buildTextSystemDefaultOptions(projectSupport)
  },
  isDisabled: ({ style }) => {
    const projectSupport = useSelector(projectSupportSelector)
    const options = buildTextSystemDefaultOptions(projectSupport)
    return style && !options.map(({ value }) => `${value}`).includes(`${style}`)
  },
  showInput: () => {
    const builderType = useSelector(builderTypeSelector)
    return builderType !== 'web-form'
  },
}

export const TextStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  SettingsLabel('Config'),
  DefaultValueInput,
  TextFormatSelect,
  TextSystemDefaultSelect,
  SendSubmissionToEmail,
  RequiredToggle,
  ReadOnlyToggle,
  ...StandardDesignConfig,
  HideOnPdfToggle,
]

export const LongTextStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  SettingsLabel('Config'),
  DefaultMultiLineValueInput,
  RequiredToggle,
  ReadOnlyToggle,
  ...StandardDesignConfig,
  HideOnPdfToggle,
]
